import React from 'react';
import { Navigate } from 'react-router-dom';

export const catchAllRoute = {
  path: '*',
  element: <Navigate to="/" replace />
};
